import React from 'react';
import llcLogo from './styles/llc-logo-dark.png';

const LlcLogo = ({ width = 250 }) => {
	return (
		<>
			<img
				src={llcLogo}
				alt='Center for the Uncounted'
				style={{
					width: width,
					marginBottom: 24,
					display: 'block',
				}}
			/>
		</>
	);
};

export default LlcLogo;
